enum STATISTIC_CATEGORY {
  GENERAL = 'GENERAL',
  TALENTS = 'TALENTS',
  HERO_TALENTS = 'HERO TALENTS',
  ITEMS = 'ITEMS',
  THEORYCRAFT = 'THEORYCRAFT',
  PANELS = 'PANELS',
}

export default STATISTIC_CATEGORY;
